module.exports = __webpack_public_path__ + "static/media/crunchbase_logo.ae457ef0.png";